module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"no_media":"添付された写真・動画のないレビューです。","filtered_review_mismatch":"選択されたレビューは現在のフィルター条件と一致しません。条件に一致する最初のレビューを表示します。","filtered_review_none":"現在のフィルター条件に一致するレビューがありません。フィルターを解除してからもう一度ご確認ください。"}}')
  delete Component.options._Ctor
}
